export default __webpack_public_path__ + "img/Inter-ExtraBoldItalic_484f101.woff2";